var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('img',{attrs:{"src":require("../../assets/main-background.jpeg"),"alt":"Clio Ragnotti N3 - Bauges 2020"}}),_c('div',{staticClass:"partners-list"},[_c('partners-list')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }